import { cn } from "@/lib/utils";

interface HashTagTextProps {
  text: string;
  newLine?: boolean;
  className?: string;
}

/**
 * 标签文本组件
 * @param text 输入的文本，包含哈希标签
 * @param className 可选的自定义类名
 * @returns 渲染后的哈希标签文本组件
 */
export const HashTagText = ({
  text,
  className,
  newLine = false
}: HashTagTextProps) => {
  if (typeof text !== 'string') return text;

  const regex = /(#[\u4e00-\u9fa5a-zA-Z0-9_]+)/g;

  if (!newLine) {
    const parts = text.split(regex);
    return (
      <>
        {parts.map((part, index) =>
          regex.test(part) ? (
            <span key={index} className={cn("text-[rgba(20,56,108,1)]", className)}>{part}</span>
          ) : part
        )}
      </>
    );
  }

  // newLine 为 true：分离正文和标签
  const bodyText = text.replace(regex, '').trim();
  const tags = text.match(regex);

  return (
    <div className="flex flex-col">
      {/* 正文区域 */}
      {bodyText && <div>{bodyText}</div>}
      <br />
      {/* 标签区域 */}
      {tags && (
        <div className="flex flex-wrap gap-x-2">
          {tags.map((tag, index) => (
            <span
              key={index}
              className={cn("text-[rgba(20,56,108,1)]", className)}
            >
              {tag}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};